import React from 'react';

import { Typography } from 'antd';

import { useNavigate } from 'react-router-dom';

import { useLocalSelector } from '@app/services/hooks/useRedux';
import { selectIsCounterpartySpace } from '@app/store/currentSessionReducer';

interface IProps {
  name: string;
  productUid: string;
}

export const ProductLink: React.FC<IProps> = ({ name, productUid }) => {
  const navigate = useNavigate();
  const isCounterparty = useLocalSelector(selectIsCounterpartySpace);

  if (isCounterparty) {
    return <Typography.Text ellipsis={{ tooltip: name }}>{name}</Typography.Text>;
  }

  return (
    <Typography.Link
      ellipsis
      style={{ display: 'block', width: '100%' }}
      onClick={(event) => {
        event.stopPropagation();
        navigate(`/dashboard/products/${productUid}`);
      }}>
      {name}
    </Typography.Link>
  );
};
